import accountsIcon from "../../assets/icons/accountsIcon.svg";
import businessIcon from "../../assets/icons/businessIcon.svg";
import listIcon from "../../assets/icons/listIcon.svg";
import marketingIcon from "../../assets/icons/marketing.svg";
import notificationIcon from "../../assets/icons/notification.svg";
import plusIcon from "../../assets/icons/plusIcon.svg";
import profileIcon from "../../assets/icons/profileIcon.svg";
import cahtIcon from "../../assets/images/cahtIcon.svg";
import type { AuthFormValues, StatusOption } from "./types";

export const userDefaultValues: AuthFormValues = {
  first_name_fa: "",
  last_name_fa: "",
  first_name_en: "",
  last_name_en: "",
  father_name_fa: "",
  father_name_en: "",
  national_code: "",
  birthdate: "",
  is_iranian: true,
  foreign_pervasive_code: "",
  passport_number: "",
  passport_expire_date: "",
  passport_image: { url: "", preview_url: "" },
  top_national_card_image: { url: "", preview_url: "" },
  first_birth_certificate_page_image: { url: "", preview_url: "" },
  profile_picture: { url: "", preview_url: "" },
  countrycode_id: 0,
  id: 0,
  mobile: "",
  email: "",
  active: false,
  verified: false,
  banned: false,
  vanda_wallet_user: false,
  is_email_verified: true,
  role: 1,
};

export const authFormOption = [
  { title: "ایرانی", value: true },
  { title: "غیرایرانی", value: false },
];

export const userNavbarItems = [
  {
    id: 1,
    title: "ناحیه کاربری ",
    path: "/profile",
    active: true,
    icon: profileIcon,
    subNav: [],
  },
  {
    id: 2,
    title: "حساب های بانکی",
    path: "/accounts",
    active: false,
    icon: accountsIcon,
    subNav: [
      {
        id: 1,
        title: "لیست",
        path: "/list",
        icon: listIcon,
        active: false,
      },
      {
        id: 1,
        title: "ثبت حساب بانکی جدید",
        path: "/new",
        icon: plusIcon,
        active: false,
      },
    ],
  },
  {
    id: 5,
    title: " کسب و کار",
    path: "/business",
    active: true,
    icon: businessIcon,
    subNav: [
      {
        id: 1,
        title: "کسب و کارها",
        path: "/list",
        icon: listIcon,
        active: false,
      },
      {
        id: 1,
        title: " ثبت کسب و کار جدید",
        path: "/new",
        icon: plusIcon,
        active: false,
      },
    ],
  },
  {
    id: 4,
    title: "پشتیبانی",
    path: "/tickets",
    active: false,
    icon: cahtIcon,
    subNav: [
      {
        id: 1,
        title: "لیست تیکت ها",
        path: "/list",
        icon: listIcon,
        active: false,
      },
      {
        id: 2,
        title: "ثبت  تیکت جدید",
        path: "/new",
        icon: plusIcon,
        active: false,
      },
    ],
  },
  {
    id: 4,
    title: "پیام ها",
    path: "/messages",
    active: false,
    icon: notificationIcon,
    subNav: [
      {
        id: 1,
        title: "اعلانات",
        path: "/notif",
        icon: listIcon,
        active: false,
      },
      {
        id: 1,
        title: "پیام های شخصی",
        path: "/inbox",
        icon: listIcon,
        active: false,
      },
    ],
  },
  {
    id: 4,
    title: "بازاریابی",
    path: "/marketing",
    active: false,
    icon: marketingIcon,
    subNav: [
      {
        id: 1,
        title: "کاربران من",
        path: "/users",
        icon: listIcon,
        active: false,
      },
      {
        id: 1,
        title: "تسویه های من",
        path: "/settlements",
        icon: listIcon,
        active: false,
      },
    ],
  },
];

export const userAdminStatusoptions: StatusOption[] = [
  {
    option: "approved",
    text: "مورد تایید ونداپرداخت",
    style:
      "bg-success-10 w-full  flex px-6 py-2 rounded-md text-success-90 text-center justify-center items-center gap-2 ",
    imgSrc: "/icons/approved-icon.svg",
  },
  {
    option: "pending",
    text: "در انتظار بررسی ونداپرداخت",
    style: "bg-warning-10 w-full  flex px-6 py-2 rounded-md text-center justify-center items-center gap-2  ",
    imgSrc: "/icons/pending-icon.svg",
  },
  {
    option: "denied",
    text: "رد شده توسط ونداپرداخت",
    style:
      "bg-error-10  w-full  flex px-6 py-2 rounded-md text-error-90 text-center justify-center items-center gap-2",
    imgSrc: "/icons/denied-icon.svg",
  },
];

export const userActiveStatusoptions: StatusOption[] = [
  {
    option: true,
    text: "فعال",
    style:
      "bg-success-10 w-full  flex px-6 py-2 rounded-md text-success-90 text-center justify-center items-center gap-2 ",
    imgSrc: "/icons/active-icon.svg",
  },
  {
    option: false,
    text: "غیرفعال",
    style: "bg-warning-10 w-full  flex px-6 py-2 rounded-md text-center justify-center items-center gap-2  ",
    imgSrc: "/icons/disactive-icon.svg",
  },
];
